module.exports = __webpack_public_path__ + "img/invisible-dim-signin.5db409cb.svg";